import { createBrowserHistory, createMemoryHistory } from 'history';

const commonHistoryProperties = {
  /* pass a configuration object here if needed */
};

export const memoryHistory = createMemoryHistory(commonHistoryProperties);
export const browserHistory = createBrowserHistory(commonHistoryProperties);
export default browserHistory;
